import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import MainContent from "~/components/MainContent";
import Content from "~/components/Content";
import MainPage from "~/components/MainPage";
import MapPage from "~/components/MapPage";
import MessengerPage from "~/components/MessengerPage";
import ColorsPage from "~/components/ColorsPage";
import MartinekPage from "~/components/MartinekPage";
import ProgramPage from "~/components/ProgramPage";
import AnouncementPage from "~/components/AnouncementPage";
import AccommodationsPage from "~/components/AccommodationsPage";
import SeatPage from "~/components/SeatPage";
import DancePage from "~/components/DancePage";
import GalleryPage from "~/components/GalleryPage";

import Background from "~/assets/background.png";

import './index.less';

document.body.style.background = `url(${Background}) repeat center top fixed`;

window.SMap = window.SMap || {};
window.mapLoadProm = window.mapLoadProm || Promise.resolve();

const container = document.getElementById('app');
const root = createRoot(container);

// render
root.render(
	<Router>
		<MainContent>
			<Content>
				<Routes>
					<Route path="/program" element={<ProgramPage />} />
					<Route path="/martinek" element={<MartinekPage />} />
					<Route path="/messenger" element={<MessengerPage />} />
					<Route path="/colors" element={<ColorsPage />} />
					<Route path="/map" element={<MapPage />} />
					<Route path="/oznameni" element={<AnouncementPage />} />
					<Route path="/ubytovani" element={<AccommodationsPage />} />
					<Route path="/zasedaci-poradek" element={<SeatPage />} />
					<Route path="/tanec" element={<DancePage />} />
					<Route path="/galerie/:child/:type/:seo" element={<GalleryPage />} />
					<Route path="/" element={<MainPage />} />
				</Routes>
			</Content>
		</MainContent>
	</Router>,
);
